

export const GRAPHQL_URL = '/api/v2/graphql/'
